import type { CreateWelcomePostsPayload } from '@fourthwall/services/dist/MembershipsCreatorApiClient'

import type { WelcomePost } from '../types'
import { getWelcomePostPayload } from './getWelcomePostPayload'

export const getCreateWelcomePostsPayload = async (welcomePosts: Record<number, WelcomePost>) => {
  const posts: Object[] = []

  for await (const [tierId, welcomePost] of Object.entries(welcomePosts)) {
    const post = await getWelcomePostPayload(welcomePost)

    posts.push({
      post,
      tier: {
        id: Number(tierId),
      },
    })
  }

  return {
    welcomePost: {
      type: 'Different',
      posts,
    },
  } as CreateWelcomePostsPayload
}
